import React, {useEffect} from 'react';
import Footer from './footer';
import Header from './header';
import {
    useRecoilState,
} from 'recoil';
import {companiesState, homeState, teamState} from "../states";
import axios from "axios";
import LogoSvg from '../assets/images/logoOnly.svg';
import {Helmet} from "react-helmet";

const PageLayout = (props) => {
    const [companiesData, setCompaniesState] = useRecoilState(companiesState);
    const [homeData, setHomeState] = useRecoilState(homeState);
    const [teamData, setTeamState] = useRecoilState(teamState);

    useEffect(() => {
        const abortController = new AbortController();
        const fetchCompaniesData = async () => {
            const companiesResponse = await axios.get('/wp-admin/admin-ajax.php?action=get_companies', {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setCompaniesState(companiesResponse)
        }
        if (companiesData.length < 1) {
            fetchCompaniesData()
        }
        return () => {
            abortController.abort()                       // stop the query by aborting on the AbortController on unmount
        }
    }, [companiesData, setCompaniesState])

    useEffect(() => {
        const abortController = new AbortController();
        const fetchTeamData = async () => {
            const response = await axios.get('/wp-admin/admin-ajax.php?action=get_team', {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setTeamState(Object.keys(response).map((e) => response[e]).flat().map((member) => {
                return {
                    ...member,
                    teams: [
                        {
                            ...member.teams[0],
                            section: member.section
                        }
                    ]
                }
            }))
        }
        if (teamData.length < 1) {
            fetchTeamData()
        }
        return () => {
            abortController.abort()                       // stop the query by aborting on the AbortController on unmount
        }
    }, [teamData, setTeamState])

    useEffect(() => {
        const abortController = new AbortController();
        const fetchHomeData = async () => {
            const homeResponse = await axios.get(`/wp-admin/admin-ajax.php?action=get_home_page_tiles`, {signal: abortController.signal}).then(resp => {
                return resp.data;
            });
            setHomeState(homeResponse)
        }
        if (Object.keys(homeData).length < 1) {
            fetchHomeData()
        }
        return () => {
            abortController.abort()                       // stop the query by aborting on the AbortController on unmount
        }
    }, [homeData, setHomeState])

    return (
        <>
            <Helmet link={[
                {
                    "rel": "icon",
                    "type": "image/svg",
                    "href": LogoSvg
                }
            ]}
            />
            <Header/>
            {props.children}
            <Footer/>
        </>
    );
};

export default PageLayout;

